// settings.js
const getBaseURL = () => {
  return process.env.REACT_APP_API_URL || "https://localhost:7163";
};

export const baseURL = getBaseURL();
export const vvUniversityLogin =
  process.env.REACT_APP_VV_UNIVERSITY_LOGIN ||
  "https://devlogin.vectorvest.com/thoughtlogin/sign-in/";
export const vvLogin =
  process.env.REACT_APP_VV_LOGIN ||
  "https://qa.vectorvest.com/accountlogin/sign-in/";
export const vvLogin2 =
  process.env.REACT_APP_VV_LOGIN2 ||
  "https://devlogin.vectorvest.com/storelogin/sign-in/?returnUrl=";
export const vvLogout =
  process.env.REACT_APP_VV_LOGOUT ||
  "https://login.vectorvest.com/accountlogin/sign-out/";
export const vvEmailPreference =
  process.env.REACT_APP_VV_EMAIL_PREFERENCE ||
  "https://news.vectorvest.com/EmailPreferenceCenter-RW.html";
export const vvPlanPage2 =
  process.env.REACT_APP_VV_PLAN_PAGE2 ||
  "https://vectorvest.com/ecommerce2/Plans";
export const captchaKey =
  process.env.REACT_APP_GOOGLE_CAPTCHA_KEY ||
  "6LcIdMQpAAAAAD96cMrLXmLrtQtrUUxQCJW7qTfC";
export const vvTrialOffer =
  process.env.REACT_APP_VV_TRIAL_OFFER ||
  "https://offers.vectorvest.com/getting-started/trial";
export const vvPlanPage =
  process.env.REACT_APP_VV_PLAN_PAGE ||
  "https://www.vectorvest.com/ecommerce/Plans";
export const gtmId = process.env.REACT_APP_GTM_ID || "GTM-NTMTTDV";
export const vvMLTrialOffer =
  process.env.REACT_APP_VV_ML_TRIAL_OFFER ||
  "https://offers.vectorvest.com/getting-started/ml-trial";
